<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
            <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content" v-if="persons && persons.length >= 1">

            <div v-for="person in persons" style="display: flex;font-size: 12px;padding: 5px 0;align-items: center;width: 100%;border-bottom:1px solid #eee;">
                <div class="picture">
                    <figure>
                        <i v-if="!person.user.clientable.picture" class="icon icon-icon_person"></i>
                        <img v-if="person.user.clientable.picture" :src="person.user.clientable.picture.url+'/fit/100x100'"/>
                    </figure>
                </div>
                <div style="padding-right: 20px;padding-left: 10px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    <strong style="font-weight: 800;font-size: 1.1em; margin-bottom: 0.3em; display: block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                        {{ person.user.clientable.name }}
                    </strong><p style="text-transform: uppercase;">{{ person.user.email }}</p>
                </div>
                <div style="margin-left: auto;font-size: 16px; width: 30%; text-align: right;padding: 0px 10px;">
                    <strong style="font-weight: 800;display: block;">{{ person.amount_total }} {{ currency }}</strong>
                </div>
            </div>

        </div>
        <div class="widget-content" v-else >
            <p style="font-size: 12px;">Aucun résultat trouvé</p>
        </div>
    </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';

    export default {
        name: 'Widget',
        props: ['title','branch','period','className'],
        data () {
            return {
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                ],
                loaded: false,
                persons: null,
                currency: null,
                branch_id: null
            }
        },
        mounted: function(){

            this.period = this.period ? this.period : this.periods[0].id
            this.branch_id = this.branch ? this.branch : null
            this.filterByPeriod(this.period);
            this.currency = this.$store.state.scope.currency_id

        },
        methods: {
            filterByPeriod: function(period)
            {
                this.loaded = false;
                this.period = period
                InvoiceService.getStatsByUsers( this.period, this.branch_id ).then((response) => {
                    this.persons = response.data.result;
                    this.loaded = true;
                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/OrderByUserWidget.vue